import React from 'react';
import { Box, Card, Container, Grid, Typography } from '@mui/material';
import image from '../../assets/career_header.jpg';
import homepage2 from '../../assets/realistic-camera-lens-with-reflections-3d-rendering.jpg';
import leavel from "../../assets/leaveimage1.png";
import leave2 from "../../assets/leaveimage2.png";
import leave3 from "../../assets/leaveimage3.png";
import Diversity1OutlinedIcon from '@mui/icons-material/Diversity1Outlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import PsychologyOutlinedIcon from '@mui/icons-material/PsychologyOutlined';
import AirplaneTicketOutlinedIcon from '@mui/icons-material/AirplaneTicketOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
// import './index.css';
import '../career/index.css'
import CareerSlider from './slider';
import { height } from '@fortawesome/free-brands-svg-icons/fa42Group';
const CareerPage = () => {
    return (
        <Container
            disableGutters
            maxWidth={false}
            style={{ padding: '0', margin: '0', position: 'relative', textAlign: 'center' }} // Remove any padding or margin
        >
            <Box style={{ position: 'relative', textAlign: 'center' ,height:"100%"}}>

              <CareerSlider/>
                <Typography
                    variant='h2'
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        fontFamily: 'Poppins, sans-serif', // Font family set to Poppins
                        color: 'white',
                        borderTop:"1px solid grey" ,
                        borderLeft:"1px solid grey",
                        borderRight:"1px solid grey",
                        padding:"10px"
                    }}
               className='poppins-bold'  >
                    JOIN OUR TEAM
                </Typography>
            </Box>
            <Container style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', marginTop: '50px', marginBottom: "50px", justifyContent: 'space-between' }}>
                <Grid container spacing={5}>
                    <Grid item xs={12} md={6} lg={6} >
                        <Typography
                            variant='h4'
                            style={{
                                color: "#0B77A8",
                                fontFamily: "Poppins, sans-serif",
                                fontWeight: "600",
                                marginRight: '40px', // Space between the title and the paragraph
                                marginLeft: '0', // Remove left margin or adjust as needed
                                textAlign: 'left', // Align text to the left
                                whiteSpace: 'nowrap', // Prevent the text from wrapping to a new line
                                overflow: 'hidden', // Hide overflow text
                                textOverflow: 'ellipsis' // Add ellipsis for overflow text if needed
                            }}
                        >
                            Working @ Edgology
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography component='p' className='"poppins-regular'
                            sx={{
                                color: "#5A5959",
                               
                                lineHeight: "1.5",
                                flex: 1, // Allow the paragraph to take up remaining space
                                textAlign: 'left', // Align text to the left for the paragraph
                                margin: '0', // Remove default margins to better align with the heading
                                minHeight: '5em',
                                marginLeft: "30px",
                                fontSize:{
                                    xl:"1.5rem",
                                    lg:"0.8rem",
                                    md:"1rem",
                                    sm:"0.8rem",
                                    xs:"0.7rem"
                                }
                            }}
                        >
                            Edgology is a dynamic and innovative company that is revolutionizing the education industry.
                            Our mission is to empower learners of all ages with the knowledge and skills they need to succeed in the 21st century.
                            We believe in creating a stimulating and collaborative environment where our team members can thrive and make a meaningful impact.
                        </Typography>
                    </Grid>
                </Grid>


            </Container>



            <Grid container style={{
                display: "flex",
                // alignItems: "center", // Center items vertically
                // justifyContent: "center", // Center items horizontally
                marginTop: '20px', // Top margin for spacing
                padding: '40px 20px', // Padding for the container
                backgroundColor: "#F4F7FC", // Background color for the container
                // borderRadius: '10px', // Rounded corners
                // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' // Subtle shadow for depth
                marginBottom: "40px"
            }}>
                <Grid item md={7} lg={6} style={{ marginRight: '20px' }}>
                    <img
                        src={homepage2}
                        alt='image-2'
                        style={{
                            maxWidth: '100%',
                            height: '300px',
                            objectFit: 'cover' // Ensure the image covers its area properly
                        }}
                    />
                </Grid>

                <Grid item md={4} lg={4} style={{ textAlign: 'left' }}>
                    <Typography variant='h5'  className='poppins-semibold'  style={{ display: "flex", alignItems: "center", marginBottom: '20px' }}>
                        <span style={{ marginRight: '10px' }}>Who</span>
                        <span style={{ color: "#00A9E0", marginRight: '10px' }}>We</span>
                        <span>Are</span>
                    </Typography>
                    <p style={{
                        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif",
                        lineHeight: "1.6em",
                        fontSize: "auto", // Adjusted font size for better readability
                        fontStyle: "normal",
                        marginTop: "20px",
                        textAlign: "left"
                    }}  className='poppins-regular' >
                        Edgology is a dynamic IT company at the forefront of educational technology. We specialize in developing innovative software solutions that transform the way people learn and teach. Our mission is to empower learners of all ages with the tools and resources they need to succeed in the digital age. We are committed to providing high-quality, user-friendly products that meet the evolving needs of our customers. Join us at Edgology and be part of a team that is shaping the future of education.
                    </p>
                </Grid>
            </Grid>
            <section maxWidth={false} style={{ padding: '0', margin: '0', position: 'relative', textAlign: 'center', paddingBottom: "60px" }} >
                <Typography
                    variant="h3"
                    // className="sixtyfour-convergence"
                    style={{
                        color: "#0B77A8",
                        fontWeight: "500",
                        paddingTop: "50px",
                        paddingBottom: "50px"
                    }}
                    className='poppins-semibold'  >
                    Why Choose Us
                </Typography>

                <Grid container style={{ alignItems: "center", paddingLeft: "50px", paddingRight: "50px" }} spacing={5}>

                    <Grid item xs={12} sm={12} md={4}>
                        <Box
                            component="img"
                            src={leavel}
                            sx={{
                                // width: '100%', // Reference size for first image
                                height: '100px'
                            }}

                        />
                        <Typography variant='h5' style={{  color: "black" }} className='poppins-medium'>
                            Trainee Opportunities
                        </Typography>
                        <Typography component='p' className='poppins-regular' style={{ color: "#6A6A6A" }}>We believe in the power of doing, not just watching. Immerse yourself in projects that matter, gaining insights that textbooks can't offer.</Typography>

                    </Grid>
                    <Grid item xs={12} sm={12} md={4}>
                        <Box
                            component="img"
                            src={leave2}
                            sx={{
                                
                                // width: '100%', // Reference size for first image
                                height: '100px'
                            }}

                        />
                       <Typography variant='h5' style={{  color: "black" }} className='poppins-medium'>
                            Immersion Internships
                        </Typography>
                        <Typography className='poppins-regular' style={{ color: "#6A6A6A" }}>Say goodbye to theoretical learning alone. Our internships offer a front-row seat to the real world, where knowledge comes alive through hands-on experiences.</Typography>

                    </Grid>
                    <Grid item xs={12} sm={12} md={4}>
                        <Box
                            component="img"
                            src={leave3}
                            sx={{
                                // width: '100%', // Reference size for first image
                                height: '100px'
                            }}

                        />
                    <Typography variant='h5' style={{  color: "black" }} className='poppins-medium'>
                            Became Consultant
                        </Typography>
                        <Typography component='p' className='poppins-regular' style={{ color: "#6A6A6A" }}>Join our dynamic team of tech-savvy consultants! We're hiring professionals passionate about solving complex tech problems. Be part of our mission to drive digital transformation..</Typography>

                    </Grid>
                </Grid>
            </section>
            <section style={{ backgroundColor: "#FBFDFC", fontFamily: "'Inter', Arial, Helvetica, sans-serif", lineHeight: "1.5", fontSmooth: "antialiased", padding: "4rem 3rem", textAlign: "center", marginTop: "10px" }}>
                <Typography variant='h4' style={{ fontWeight: "600", paddingBottom: "33px" }} className='poppins-bold'>
                    Benefits & Perks
                </Typography>
                <Grid container spacing={5} style={{ paddingTop: "30px" }}>
                    <Grid item xs={12} sm={12} md={6} lg={4} >
                        <Diversity1OutlinedIcon style={{ fontSize: "xx-large" }} />
                        <Typography variant='h5'    className='poppins-medium' >
                            Health & Retirement
                        </Typography>
                        <Typography component='p' className="poppins-regular" style={{ fontWeight: "400", fontSize: "16px", color: "#022022" }}>Employee-covered health care and retirement match</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} >
                        <CalendarMonthOutlinedIcon style={{ fontSize: "xx-large" }} />
                        <Typography  className='poppins-medium'  variant='h5' >
                            Flexible Time-off & Closures
                        </Typography>
                        <Typography component='p' className="poppins-regular" style={{ fontWeight: "400", fontSize: "16px", color: "#022022" }}>Prioritized work-life balance, with flexible time-off, paid holidays and recharge weeks</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} >
                        <PsychologyOutlinedIcon style={{ fontSize: "xx-large" }} />
                        <Typography variant='h5'  className='poppins-medium' >
                            Mental Wellness
                        </Typography>
                        <Typography component='p' className="poppins-regular" style={{ fontWeight: "400", fontSize: "16px", color: "#022022" }}>Wellbeing allowance and free access to HeadSpace and Spring Health</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} >
                        <AirplaneTicketOutlinedIcon style={{ fontSize: "xx-large" }} />
                        <Typography variant='h5'  className='poppins-medium'  >
                            Family Planning
                        </Typography>
                        <Typography component='p' className="poppins-regular" style={{ fontWeight: "400", fontSize: "16px", color: "#022022" }}>Paid parental leave, adoption assistance, and reproductive health assistance</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} >
                        <LightbulbOutlinedIcon style={{ fontSize: "xx-large" }} />
                        <Typography variant='h5'  className='poppins-medium'  >
                            Learning & Development
                        </Typography>
                        <Typography component='p' className="poppins-regular" style={{ fontWeight: "400", fontSize: "16px", color: "#022022" }}>Professional development training, speakers series, and annual education allowance</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} >
                        <EmojiEventsOutlinedIcon style={{ fontSize: "xx-large" }} />
                        <Typography variant='h5'  className='poppins-medium'  >
                            Perks and Stipends
                        </Typography>
                        <Typography component='p' className="poppins-regular" style={{ fontWeight: "400", fontSize: "16px", color: "#022022" }}>IKEA discount, Taskrabbit credit, and productivity stipend</Typography>
                    </Grid>
                </Grid>
                <Typography component='p' className="poppins-regular" style={{ alignItems: "center", textAlign: "center", paddingTop: "40px" }}>And More!</Typography>
            </section>
            <Box style={{ padding: "10px", margin: "20px", paddingTop: "50px", textAlign: "center", paddingBottom: "40px" }} >
                <Grid container style={{ display: "flex", textAlign: "left" }}>
                    <Grid item xs={12} md={4} lg={5} style={{ textAlign: "center" }}>
                        <Typography variant='h5' style={{ color: "#0B77A8" }} className='poppins-semibold'>Opening Role</Typography>
                    </Grid>
                    <Grid item xs={12} md={6} lg={6} style={{paddingBottom:"30px"}}>
                        <Typography component='p' style={{ marginTop: "0px" }} >
                            <Typography variant='h5'  className='poppins-medium' style={{paddingBottom:"20px"}}>Embrace Opportunities in Our Job Openings</Typography>
                            <Typography component='span'  className='poppins-regular'>Welcome to a realm where passion meets purpose, and dreams become realities. Join the league of visionary professionals at Edgology Technologies the driving force behind projects that are not just shaping industries, but redefining them.</Typography>
                        </Typography>
                    </Grid>

                </Grid>
                <p style={{ color: "red" }}>Currently, there are no openings, We'll keep your CV for consideration when positions become available.
                </p>
                <p>Please Mail your CV  hr@Edgology.com</p>
            </Box>
            {/* <section >
            <Grid Container spacing={5} style={{padding:"10px"}} >
                <Grid item xs={8} md={6} style={{textAlign:"left"}}>
                    <Typography variant='h4' style={{fontFamily:"'Google Sans Display',Roboto,Arial,sans-serif",lineHeight:"4.75 rem",fontSize:"4 rem",fontWeight:"400"}}>Our Location</Typography>
                    <p style={{fontFamily:"Roboto,Arial,sans-serif",letterSpacing:"0.0125em",color:"rgb(95,99,104)",fontWeight:"400",lineHeight:"1.5rem",marginBottom:"10px"}}>Large or small, each one of our offices is designed to inspire innovation, big ideas and community.</p>
                    </Grid>  
                <Grid item xs={4} md={6}>
                    <Box component='img' ></Box>
                    </Grid>  
            </Grid>
          </section> */}
        </Container>
    )
}

export default CareerPage;
